import { axiosUpdateHeaders } from '@/http'
import { state, mutations, SET_LOADING, RESET_LOADING } from '@/store/modules/common'
import verifyAge from '@/utils/verifyAge'
import _ from 'underscore'

const SET_RESULTS = 'SET_RESULTS'
const RESET_RESULTS = 'RESET_RESULTS'

export const actions = {
  getTravelers ({ commit }) {
    const axios = axiosUpdateHeaders()
    commit(SET_LOADING)

    return axios.get('/api/user/travelers')
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data)
        }
      }, error => {
        commit(RESET_LOADING)
        return Promise.reject(error.response)
      })
  },

  getTravelersParent ({ commit }) {
    const axios = axiosUpdateHeaders()
    commit(SET_LOADING)
    commit(RESET_RESULTS)

    return axios.get('/api/user/travelers/parent')
      .then(response => {
        if (response.status === 200) {
          commit(SET_RESULTS, response.data)
          commit(RESET_LOADING)
          return Promise.resolve(response.data)
        }
      }, error => {
        commit(RESET_LOADING)
        return Promise.reject(error.response)
      })
  },

  getTraveler ({ commit }, id) {
    const axios = axiosUpdateHeaders()

    return axios.get('/api/user/', {params: {id: id}})
      .then(response => {
        if (response.status === 200 && response.data.birth_date !== null) {
          commit(SET_RESULTS, response.data)
        }
      }, error => {
        commit(RESET_LOADING)
        return Promise.reject(error.response)
      })
  },

  searchTravelers ({ commit, dispatch }) {
    const axios = axiosUpdateHeaders()
    commit(SET_LOADING)
    commit(RESET_RESULTS)

    return axios.get('/api/user/')
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          for (const traveler of response.data.results){
            dispatch('getTraveler', traveler.id)
          }
        }
      }, error => {
        commit(RESET_LOADING)
        return Promise.reject(error.response)
      })
  },

  postTraveler ({ commit, dispatch }, data) {
    const axios = axiosUpdateHeaders()
    commit(SET_LOADING)

    return axios.post('/api/user/traveler/', data)
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          dispatch('getTravelersParent')
          return Promise.resolve(response.data)
        } else {
          commit(RESET_LOADING)
          return Promise.reject(response.data)
        }
      }, error => {
        commit(RESET_LOADING)
        return Promise.reject(error.response.data.message)
      })
  }
}

export const getters = {
  travelersCanBooking: (state) => (order) => {
    return state.results.filter(result => {
      if (!result.document_number || !result.email) {
        return false
      }
      if (result.birthdate){
        if (verifyAge(result.birthdate, order.start_date) !== 'adults') {
          return false
        }
      }
      return true
    })
  },

  travelersByAgeRange: (state) => (order) => {
    return state.results.map(result => ({
      ...result,
      age_range: verifyAge(result.birthdate, order.date_outbound, order.date_inbound)
    }))
  }
}

export default {
  namespaced : true,
  state: {
     ...state,
     results: []
  },
  mutations: {
    ...mutations,
    [SET_RESULTS](state, payload) {
      state.results = _.sortBy(payload.map(result => ({
      ...result,
      full_name: result.name.trim(),
    })), 'full_name')
    },
    [RESET_RESULTS](state) {
      state.results = []
    }
  },
  actions,
  getters
}
